<script>
    import {push} from "svelte-spa-router";
    import {_} from "svelte-i18n";

    export let onSite = false;
    let hbLink;
    let hbText;
    let hbImage;

    if (onSite) {
        hbLink = "/highlights";
        hbText = $_("highlights_title");
        hbImage = "./images/dashboard/highlights2.jpg";
    } else {
        hbLink = "/content";
        hbText = $_("media_title");
        hbImage = "./images/dashboard/digital.jpg";
    }
</script>

<div class="rowMediathek pCursor" on:click={() => push(hbLink)}>
    <img src={hbImage} class="mediathek unset imageBlur" alt={hbText}/>
    <div class="headline-xs beyeler">{hbText}</div>
</div>
<div>
    <div class="divider-h "/>
</div>

<style>
    .rowMediathek {
        display: flex;
        flex-direction: row;
        justify-content: left;
        margin-top: 22px;
        margin-bottom: 22px;
        width: 100%;
    }

    .beyeler {
        height: 110px;
        display: flex;
        flex-direction: column;
        justify-content: end;
        margin-left: 13px;
        padding-right: 45px;
    }

    .mediathek {
        object-fit: cover;
        width: 100%;
        height: 110px;
        margin-bottom: 8px;
        display: block;
    }

    @media only screen and (min-width: 530px) {
        .mediathek {
            height: 200px;
        }

        .beyeler {
            height: 200px;
        }
    }

    @media only screen and (min-width: 800px) {
        .rowMediathek {
            display: flex;
            flex-direction: column;
            justify-content: unset;
            margin-top: 0px;
            margin-bottom: 48px;
        }


        .beyeler {
            height: unset;
            display: unset;
            flex-direction: unset;
            justify-content: unset;
            margin-left: unset;
        }

        .mediathek {
            height: 200px;
            margin-bottom: 16px;
        }
    }

    @media only screen and (min-width: 1080px) {
        .mediathek {
            height: 333px;
        }
    }

    @media only screen and (min-width: 1728px) {
        .mediathek {
            height: 373px;
        }
    }

    @media only screen and (min-width: 1920px) {
        .mediathek {
            height: 403px;
        }
    }
</style>
